import {Children} from "react";
import {grey25, sidebarColor} from "assets/jss/main";


const sideBarMaxWidth = '240px';
const sideBarRightMargin = '16px';
const sideBarRadius = '8px';
const contentMargin = '24px 16px';
function WmsDesktopLayout({children}) {
    const SideBarPart = findSlotOfType(children, SideBar);
    const ContentPart = findSlotOfType(children, Content);

    return(
        <div style={{
            width: '100%',
            height: '100vh',
            backgroundColor: grey25,
            display: 'flex',
            marginLeft: '240px' // for the sidebar
        }}>
            <aside className="wms-mobile-header" style={{
                backgroundColor: sidebarColor,
                marginRight: sideBarRightMargin,
                maxWidth: sideBarMaxWidth,
                borderRadius: sideBarRadius,

            }}>
                {SideBarPart}
            </aside>
            <section style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                flex: 1,
                overflowY: 'auto',
                margin: contentMargin
            }}>
                {ContentPart}
            </section>
        </div>
    )

}

function findSlotOfType(children, slotType) {
    return Children.toArray(children).find((child) => child.type === slotType);
}

function SideBar ({children}) {
    return (
        <div>
            {children}
        </div>
    )
}

function Content ({children}) {
    return (
        <div>
            {children}
        </div>
    )
}

export default Object.assign(WmsDesktopLayout, { SideBar, Content });
